import {DealInfo} from "./DealInfo/DealInfo";
import {SectionLabel} from "../../common/SectionLabel";


export const DealsInfo = ({dealsInfo, onDealDelete}) => {
    return (
        <>
            {/* М1: надписът стои и когато няма редове — така структурата на
                страницата е една и съща и се вижда, че тук просто няма замени. */}
            <SectionLabel>Доброволна замяна</SectionLabel>
            <div className="d-flex justify-content-center">
                <table className="table">
                    <thead>
                    <tr>
                        <th className="text-center" scope="col">Дата</th>
                        <th className="text-center" scope="col">Въведена от</th>
                        <th className="text-center" scope="col">Получена/дадена</th>
                        <th className="text-center" scope="col">от/за село</th>
                        <th className="text-center" scope="col">взимащ/даващ</th>
                        {/* К: одобрявам / не одобрявам / уредено — преди редакцията */}
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    {dealsInfo.map(deal => (<DealInfo key={deal.id} {...deal} onDealDelete={onDealDelete}/>))}
                    </tbody>
                </table>
            </div>
        </>
    );
};
